import Vue from 'vue'
import App from './components/App/App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Draggable from 'vuedraggable';
import { prepareServices } from './plugins'
import { abilitiesPlugin } from '@casl/vue';
import MultiFiltersPlugin from './plugins/MultiFilters';
// #. application layouts
import Default from './layouts/Default.vue';
import Menu from './layouts/Menu.vue';
import Admin  from './layouts/Admin.vue';
import Public  from './layouts/Public.vue';
import cmt from '@pan-gms/comments-manager';
import ability from '@/plugins/abilities';
import VueCurrencyInput from "vue-currency-input";

Vue.use(VueCurrencyInput);
Vue.use(abilitiesPlugin, ability);

Vue.component('default-layout', Default);
Vue.component('menu-layout', Menu);
Vue.component('admin-layout', Admin);
Vue.component('public-layout', Public);

Vue.use(cmt);

/*
  * Root Import CSS
*/
// import 'bootstrap';
import './styles/font.css';
import './styles/site.css';
import './styles/grid.css';
import './styles/component.css';
import './styles/vuetify1.5.css';
import './styles/vuetify2.0.css';
import './styles/contextmenu.css';
import './styles/dense.css';
//import './styles/custom.css';
import './styles/iucn/style.css';
import './styles/iucn/header.css';
import './styles/iucn/footer.css';
import './styles/iucn/block.css';
import './styles/iucn/layout.css';

Vue.config.productionTip = false

Vue.component('draggable', Draggable)

import { i18n, loadLanguageAsync } from "@/plugins/i18n";

loadLanguageAsync(localStorage.getItem("language") ||'en-US');

prepareServices(store).then(() => {
  Vue.use(MultiFiltersPlugin);
  new Vue({
    router,
    i18n,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})


